export const defaultConfiguration = {
    rediApiUser: 'busqueda@red-i.com.ar',
    rediApiPass: 'HGQFYkhdVxG2QCy4',
    defaultImage: 'null'
}